import Navbar from "../Components/NavbarItems/Navbar";
import Footer from "../Components/FooterItems/Footer";
import PoushVideo from "../Components/Multimedia/Videos/PoushVideo";

function PoushVDO() {
  return (
    <>
      <Navbar />
      <PoushVideo />
      <Footer />
    </>
  );
}

export default PoushVDO;
